module.exports = __webpack_public_path__ + "static/media/ToyotaLogo.e5d6b0a4.svg";